import React, { useState, useEffect, Suspense } from "react";
import {
  Image,
  Button,
  Tooltip,
  Card,
  Pagination,
  Spinner,
  useDisclosure,
  Link,
} from "@heroui/react";
import { getGameDeckBuilderConfig } from "@/games";
import {
  IconLayoutBottombar,
  IconLayoutSidebar,
  IconMaximize,
  IconCards,
} from "@tabler/icons-react";
import DeckStats from "@/components/Decklists/DeckStats";
import { SortableRect } from "@/components/DeckBuilder/SortableRect";
import html2canvas from "html2canvas";
import { DivToImage } from "@/components/DeckBuilder/html2canvas";
import Export from "@/components/DeckBuilder/Mobile/Export";
import LAYOUTS from "@/components/DeckBuilder/layouts";
import { useDeckItems, useCurrentGame } from "@/stores/deckStore";
import { CDN } from "@/lib/cdn";
import CardArt from "@/components/Card/CardArt";
import { orientationOfCard } from "@/lib/cardArt";

export default function DeckLayoutMax({
  handleOpen,
  getCount,
  copyDeck,
  deck,
  setLayout,
  setHoveredAACardId,
}: {
  handleOpen: any;
  getCount: any;
  copyDeck: any;
  deck: any;
  setLayout: any;
  setHoveredAACardId: any;
}) {
  const game = useCurrentGame();
  const deckItems = useDeckItems();
  const gameConfig = getGameDeckBuilderConfig(game);
  const { getCardImage, getCardData } = gameConfig;

  let newDisplayDeck = [];
  for (let i = 0; i < deckItems.length; i++) {
    const curCard = deckItems[i];
    const cardData = getCardData(curCard.id);
    newDisplayDeck.push(
      <div key={curCard.id}>
        <CardArt
          src={getCardImage(curCard.id)}
          alt={cardData?.name || curCard.id}
          orientation={orientationOfCard(game, cardData)}
          radiusClassName="rounded-[10px]"
        />
      </div>,
    );
  }

  let leaderData;
  let leader = deck.getLeaderId();
  if (leader) {
    leaderData = getCardData(leader);
    console.log(leaderData);
  }

  return (
    <div className="mt-4 mb-10">
      <div className="flex items-center gap-2 pb-2">
        <div className="w-[48px] mt-3">
          <Link href="/">
            <Image
              src={`${CDN}/shared/logo/gumgum.png`}
              loading="eager"
              alt="gumgum.gg OPTCG fan site"
              height={48}
              width={48}
              className="sm:mb-2"
            />
          </Link>
        </div>
        <div className="flex flex-row gap-2 w-[100px]">
          <IconCards />
          {getCount()} cards
        </div>
        {/* <Button
          size="sm"
          isIconOnly
          variant="ghost"
          color="primary"
          onPress={() => setLayout("side")}
        >
          <IconLayoutSidebar />
        </Button> */}
        <Button
          size="sm"
          // variant="ghost"
          color="primary"
          startContent={<IconLayoutBottombar height={18} width={18} />}
          className="text-sm"
          onPress={() => setLayout(LAYOUTS.EDIT)}
        >
          Edit Deck
        </Button>
        {/* <Button
          size="sm"
          isIconOnly
          variant="ghost"
          color="primary"
          onPress={() => setLayout("max")}
        >
          <IconMaximize />
        </Button> */}
        <div className="ml-auto w-[500px]">
          <Export deck={deck} />
        </div>
      </div>
      <div>
        <div className="mt-4 flex flex-col gap-2">
          <div className="grid grid-cols-6 gap-5">
            <SortableRect
              handleOpen={handleOpen}
              cardSize="lg"
              disableClick={true}
              setHoveredAACardId={setHoveredAACardId}
            />
            {/* {newDisplayDeck} */}
          </div>
        </div>
      </div>
      {getCount() === 0 ? (
        <div className="w-full flex items-center justify-center p-10">
          No Cards in Deck
        </div>
      ) : (
        <DeckStats
          leaderLife={
            leaderData && gameConfig.hasLifeProperty && "life" in leaderData
              ? leaderData.life || 5
              : 5
          }
          decklist={deck.getDecklist(false)}
        />
      )}
    </div>
  );
}
